import React from 'react';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SOCIAL_NETWORK, ALL_RESERVED } from '../../constants';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  return (
    <div className="footer-container">
      <div className="footer-info-container">
        <div className="row-container row-container-1">
          <img
            border="0"
            alt="logo-lefebvre"
            src='/assets/images/logo-lefebvre.svg'
            width="150px"
            height="40px"
          />
          <div className="icons-social">
            <img
              src="/assets/images/instagram.svg"
              alt="Instagram"
              className="network-link"
              onClick={() => {
                window.open(SOCIAL_NETWORK.instagram, "_blank");
              }}
            />
            <img
              src="/assets/images/facebook.svg"
              alt="Facebook"
              className="network-link"
              onClick={() => {
                window.open(SOCIAL_NETWORK.facebook, "_blank");
              }}
            />
            <img
              src="/assets/images/linkedin.svg"
              alt="LinkedIn"
              className="network-link"
              onClick={() => {
                window.open(SOCIAL_NETWORK.linkedin, "_blank");
              }}
            />
            <img
              src="/assets/images/x.svg"
              alt="X"
              className="network-link"
              onClick={() => {
                window.open(SOCIAL_NETWORK.twitter, "_blank");
              }}
            />
            <img
              src="/assets/images/youtube.svg"
              alt="YouTube"
              className="network-link"
              onClick={() => {
                window.open(SOCIAL_NETWORK.youtube, "_blank");
              }}
            />
          </div>
        </div>
        <div className="row-container all-rights-reserved-container">
          <p className="text-all-rights-reserved">
            <span>
              {t('footer.all_rights_reserved').replace('{}', currentYear)}
            </span>
            <span
              className="ml-2 footer-link"
              onClick={() => {
                window.open(ALL_RESERVED.terms, "_blank");
              }}>
              {t('footer.terms')}
            </span>
            <span
              className="footer-pointer-link"
              onClick={() => {
                window.open(ALL_RESERVED.privacy, "_blank");
              }}>
              <span className="footer-link">
                {t('footer.privacy')}
              </span>
            </span>
            <span
              className="footer-pointer-link"
              onClick={() => {
                window.open(ALL_RESERVED.cookies, "_blank");
              }}>
              <span className="footer-link">
                {t('footer.cookies')}
              </span>
            </span>
          </p>
        </div>
      </div>
      <div className="footer-border" />
    </div>
  );
};

const mapStateToProps = state => ({
  lastConnection: state.currentUser.lastConnection
});

export default connect(mapStateToProps)(Footer);
